/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import INITIAL_STATE from './initial_state';

import { OnlineSearchTypes, OnlineSearchState } from './types';

const reducer: Reducer<OnlineSearchState> = (
  state = INITIAL_STATE,
  {
    type,
    value,
    field,
    currentPage,
    postsPerPage,
    filterActive,
    states_from_panel,
    orderedBy,
    orderDirection,
  },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case OnlineSearchTypes.CLEAR_FILTER:
        draft.onlineSearch.filters = INITIAL_STATE.onlineSearch.filters;
        draft.onlineSearch.filterActive = INITIAL_STATE.onlineSearch.filterActive;
        break;

      case OnlineSearchTypes.CHANGE_VALUE:
        draft.onlineSearch.filters = { ...state.onlineSearch.filters, [field]: value };
        break;

      case OnlineSearchTypes.UPDATE_CURRENT_PAGE:
        draft.onlineSearch.currentPage = currentPage;
        break;

      case OnlineSearchTypes.UPDATE_POSTS_PER_PAGE:
        draft.onlineSearch.postsPerPage = postsPerPage;
        break;

      case OnlineSearchTypes.FILTER_ACTIVE:
        draft.onlineSearch.filterActive = filterActive;
        break;

      case OnlineSearchTypes.UPDATE_STORE_FIELDS:
        if (!state.onlineSearch.currentPage)
          draft.onlineSearch.currentPage = INITIAL_STATE.onlineSearch.currentPage;

        if (!state.onlineSearch.postsPerPage)
          draft.onlineSearch.postsPerPage = INITIAL_STATE.onlineSearch.postsPerPage;
        break;

      case OnlineSearchTypes.STATE_FROM_PANEL:
        draft.onlineSearch.state_from_panel = states_from_panel;
        break;

      case OnlineSearchTypes.HANDLE_ORDER:
        draft.onlineSearch.orderedBy = orderedBy;
        draft.onlineSearch.orderDirection = orderDirection;
        break;

      default:
        break;
    }
  });
};

export default reducer;
